// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fUVA","field":"styles_field__1sMV0","fieldCol":"styles_fieldCol__2ZRLO","diffCol":"styles_diffCol__3Q89D","diff":"styles_diff__3L7lu"};